<template>
    <!-- Skeleton loader mientras carga -->
    <div class="loading-skeleton">
      <Skeleton height="3rem" class="mb-3" />
      <Skeleton height="3rem" class="mb-3" />
    </div>
</template>

<style scoped>
  .loading-skeleton {
    padding: 1rem 0;
  }
</style>